// src/Data/SkillsData.js

export const skillsData = [
  // Programming & Query Languages
  "Python",
  "R",
  "SQL",

  // Data Science & ML Libraries
  "Pandas",
  "NumPy",
  "Matplotlib",
  "Seaborn",
  "Scikit-Learn",
  "TensorFlow",
  "Keras",
  "PyTorch",
  "Hugging Face Transformers",
  "OpenCV",

  // Big Data & Cloud
  "Apache Spark",
  "Hadoop",
  "Kafka",
  "Jupyter Notebook",
  "Streamlit",
  "Docker",

  // Databases
  "MySQL",
  "PostgreSQL",

  // Visualization & BI
  "Tableau",
  "Power BI",
  "Excel",

  // Software Tools & Version Control
  "Git",
  "GitHub",
];
